import { SimpleFormProvider } from "../../fluidComponents/fluidForm/SimpleFormLoader";
import { FluidForm } from "../../shared.types";
import React from "react";
import { ExampleAuthWrapper } from "../ExampleAuthWrapper";
const basicFormConfig = {
    "key": "example-form2",
    "label": "Example Form",
    "description": "",
    // "useGoogleDrive": false,
    "strictness": "strict",
    "fields": [
        {
            key: "Personal Information",
            label: "Personal Information",
            type: "section"
        },
        {
            "key": "name",
            "label": "Name",
            "type": "fullName"
        },
        {
            "key": "email",
            "label": "Email",
            "type": "email",
            "unique": true,
        },
        {
            "key": "birthDate",
            "label": "Birth Date",
            "type": "date"
        },
        {
            key: "Preferences",
            label: "Preferences",
            type: "section",
        },
        {
            key: "favoriteMovie",
            label: "Favorite Movie",
            type: "text"
        },
        {
            key: "favoriteBook",
            label: "Favorite Book",
            type: "text"
        },
        {
            "key": "favoriteColor",
            "label": "Colors",
            "type": "multipleOptions",
            "options": [
                {
                    "text": "red",
                    "value": "Red"
                },
                {
                    "text": "blue",
                    "value": "Blue"
                }
            ],
            "fields": []
        }
    ]
};
export function ChatFormPage() {
    return (React.createElement(ExampleAuthWrapper, { formConfig: basicFormConfig },
        React.createElement(ChatOnlyForm, null)));
}
function ChatOnlyForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "classic",
            layout: "chat",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "example-submission" })));
}
